module.exports = __webpack_public_path__ + "img/recruit-icon-3.3bc6af76.png";